import {
  SORT_OPTIONS,
  SortType
} from "@website/accommodation-ui/tour-result-header/tour-sort-view";

export const sorts: Array<SortType> = [
  {
    label: "پیشنهادی",
    value: SORT_OPTIONS.RECOMMENDED
  },
  {
    label: "ارزانترین",
    value: SORT_OPTIONS.CHEAPEST
  },
  {
    label: "گرانترین",
    value: SORT_OPTIONS.EXPENSIVE
  }
];
